module.exports = __webpack_public_path__ + "img/blog-1.f865146a.webp";